import httpClient from './httpClient';

const asignacionUsuarioProyectoService = {
  // Obtener todas las asignaciones de usuario-proyecto para una empresa
  async obtenerAsignaciones(empresaId) {
    try {
      console.log('🔄 Obteniendo asignaciones usuario-proyecto para empresa:', empresaId);
      const response = await httpClient.get(`/asignaciones-usuario-proyecto/empresa/${empresaId}`);
      
      console.log('✅ Asignaciones obtenidas exitosamente:', response.data);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Error al obtener asignaciones usuario-proyecto:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener asignaciones usuario-proyecto'
      };
    }
  },

  // Obtener todos los usuarios disponibles para asignar
  async obtenerUsuariosDisponibles(empresaId) {
    try {
      console.log('🔄 Obteniendo usuarios disponibles para empresa:', empresaId);
      const response = await httpClient.get(`/usuarios/empresa/${empresaId}/disponibles`);
      
      console.log('✅ Usuarios disponibles obtenidos:', response.data);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Error al obtener usuarios disponibles:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener usuarios disponibles'
      };
    }
  },

  // Obtener todos los proyectos disponibles para asignar
  async obtenerProyectosDisponibles(empresaId) {
    try {
      console.log('🔄 Obteniendo proyectos disponibles para empresa:', empresaId);
      const response = await httpClient.get(`/proyectos/empresa/${empresaId}/disponibles`);
      
      console.log('✅ Proyectos disponibles obtenidos:', response.data);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Error al obtener proyectos disponibles:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener proyectos disponibles'
      };
    }
  },

  // Crear nueva asignación usuario-proyecto
  async crearAsignacion(empresaId, usuarioId, proyectoId) {
    try {
      console.log('🔄 Creando asignación usuario-proyecto:', { empresaId, usuarioId, proyectoId });
      const response = await httpClient.post('/asignaciones-usuario-proyecto', {
        empresa_id: empresaId,
        usuario_id: usuarioId,
        proyecto_id: proyectoId
      });
      
      console.log('✅ Asignación creada exitosamente:', response.data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Asignación creada exitosamente'
      };
    } catch (error) {
      console.error('❌ Error al crear asignación:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al crear asignación'
      };
    }
  },

  // Eliminar asignación usuario-proyecto
  async eliminarAsignacion(asignacionId) {
    try {
      console.log('🔄 Eliminando asignación usuario-proyecto:', asignacionId);
      const response = await httpClient.delete(`/asignaciones-usuario-proyecto/${asignacionId}`);
      
      console.log('✅ Asignación eliminada exitosamente:', response.data);
      return {
        success: true,
        message: response.data.message || 'Asignación eliminada exitosamente'
      };
    } catch (error) {
      console.error('❌ Error al eliminar asignación:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar asignación'
      };
    }
  },

  // Actualizar asignación usuario-proyecto
  async actualizarAsignacion(asignacionId, datos) {
    try {
      console.log('🔄 Actualizando asignación usuario-proyecto:', { asignacionId, datos });
      const response = await httpClient.put(`/asignaciones-usuario-proyecto/${asignacionId}`, datos);
      
      console.log('✅ Asignación actualizada exitosamente:', response.data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Asignación actualizada exitosamente'
      };
    } catch (error) {
      console.error('❌ Error al actualizar asignación:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al actualizar asignación'
      };
    }
  },

  // Obtener asignaciones por usuario específico
  async obtenerAsignacionesPorUsuario(empresaId, usuarioId) {
    try {
      console.log('🔄 Obteniendo asignaciones para usuario:', { empresaId, usuarioId });
      const response = await httpClient.get(`/asignaciones-usuario-proyecto/empresa/${empresaId}/usuario/${usuarioId}`);
      
      console.log('✅ Asignaciones del usuario obtenidas:', response.data);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Error al obtener asignaciones del usuario:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener asignaciones del usuario'
      };
    }
  },

  // Obtener asignaciones por proyecto específico
  async obtenerAsignacionesPorProyecto(empresaId, proyectoId) {
    try {
      console.log('🔄 Obteniendo asignaciones para proyecto:', { empresaId, proyectoId });
      const response = await httpClient.get(`/asignaciones-usuario-proyecto/empresa/${empresaId}/proyecto/${proyectoId}`);
      
      console.log('✅ Asignaciones del proyecto obtenidas:', response.data);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Error al obtener asignaciones del proyecto:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener asignaciones del proyecto'
      };
    }
  }
};

export default asignacionUsuarioProyectoService;